export enum PlatformApplicationStatus {
  INCOMPLETE = 'incomplete',
  IN_PROGRESS = 'in-progress',
  PROCESS_ENDED = 'process-ended',
}
